import { createAsyncAction } from 'conversations-async-data/async-action/createAsyncAction';
import { CLOSE_THREAD } from '../constants/asyncActionTypes';
import { closeThread as closeThreadClient } from '../clients/closeThread';
export const closeThread = createAsyncAction({
  requestFn: closeThreadClient,
  actionTypes: CLOSE_THREAD,
  toRecordFn: response => response
});